import advancedFilters from './advancedFilters.json';
import agentBots from './agentBots.json';
import agentMgmt from './agentMgmt.json';
import archiveInboxes from './archiveInboxes.json';
import attributesMgmt from './attributesMgmt.json';
import auditLogs from './auditLogs.json';
import automation from './automation.json';
import automationFlows from './automationFlows.json';
import bulkActions from './bulkActions.json';
import campaign from './campaign.json';
import cannedMgmt from './cannedMgmt.json';
import flexTemplates from './flexTemplates.json';
import chatlist from './chatlist.json';
import components from './components.json';
import contact from './contact.json';
import contactFilters from './contactFilters.json';
import conversation from './conversation.json';
import csatMgmt from './csatMgmt.json';
import customRole from './customRole.json';
import datePicker from './datePicker.json';
import emoji from './emoji.json';
import engage from './engage.json';
import general from './general.json';
import generalSettings from './generalSettings.json';
import helpCenter from './helpCenter.json';
import inbox from './inbox.json';
import inboxMgmt from './inboxMgmt.json';
import integrationApps from './integrationApps.json';
import integrations from './integrations.json';
import ailab from './ailab.json';
import labelsMgmt from './labelsMgmt.json';
import login from './login.json';
import macros from './macros.json';
import report from './report.json';
import resetPassword from './resetPassword.json';
import search from './search.json';
import setNewPassword from './setNewPassword.json';
import settings from './settings.json';
import signup from './signup.json';
import sla from './sla.json';
import teamsSettings from './teamsSettings.json';
import teamManagement from './teamManagement.json';
import issuesSettings from './issuesSettings.json';
import lineStickers from './lineStickers.json';
import whatsappTemplates from './whatsappTemplates.json';
import contentTemplates from './contentTemplates.json';
import mfa from './mfa.json';
import workforce from './workforce.json';
import qaDashboard from './qaDashboard.json';
import telegramInternal from './telegramInternal.json';
import telegramSettings from './telegramSettings.json';
import voiceCall from './voiceCall.json';

export default {
  ...advancedFilters,
  ...agentBots,
  ...agentMgmt,
  ...archiveInboxes,
  ...attributesMgmt,
  ...auditLogs,
  ...automation,
  ...automationFlows,
  ...bulkActions,
  ...campaign,
  ...cannedMgmt,
  ...flexTemplates,
  ...chatlist,
  ...components,
  ...contact,
  ...contactFilters,
  ...conversation,
  ...csatMgmt,
  ...customRole,
  ...datePicker,
  ...emoji,
  ...engage,
  ...general,
  ...generalSettings,
  ...helpCenter,
  ...inbox,
  ...inboxMgmt,
  ...integrationApps,
  ...integrations,
  ...ailab,
  ...labelsMgmt,
  ...login,
  ...macros,
  ...report,
  ...resetPassword,
  ...search,
  ...setNewPassword,
  ...settings,
  ...signup,
  ...sla,
  ...teamsSettings,
  ...teamManagement,
  ...issuesSettings,
  ...lineStickers,
  ...whatsappTemplates,
  ...contentTemplates,
  ...mfa,
  ...workforce,
  ...qaDashboard,
  ...telegramInternal,
  ...telegramSettings,
  ...voiceCall,
};
